import { Component, inject, input, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { Breadcrumb } from '../models/breadcrumb.interface';
import { BreadcrumbService } from '../services/breadcrumb.service';
import { RouterModule } from '@angular/router';
import { Observable } from 'rxjs';
import { AsyncPipe, CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cec-breadcrumb',
  standalone: true,
  imports: [RouterModule, AsyncPipe, CommonModule, TranslateModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  providers: [BreadcrumbService]
})
export class BreadcrumbComponent {

  /** If breadcrumb should be visible */
  protected isVisible = input<boolean>(true);

  /** List of breadcrumbs obtained from service */
  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }
}
